package com.tovtalk.utils.config

import kotlinx.browser.window

actual object PlatformConfig {
    private const val DEFAULT_BASE_URL = "https://api.tovtalk.com/"
    
    private fun fromWindow(key: String): String? {
        val env = window.asDynamic().__ENV__
        return if (env != null && env[key] != null) env[key] as String else null
    }
    
    actual fun getApiBaseUrl(): String = fromWindow("API_BASE_URL") ?: DEFAULT_BASE_URL
    
    actual fun getApiKey(): String = fromWindow("API_KEY") ?: ""
    
    actual fun getRevenueCatAndroidKey(): String? = null
    
    actual fun getRevenueCatIosKey(): String? = null

    actual fun getAppVersionCode(): Int = 1
    actual fun setAppVersionCode(code: Int) {}
    actual fun getPlatformMinVersion(minAndroid: Int?, minIos: Int?, minWeb: Int?): Int? = minWeb
}
